var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fadeIn"}},[_c('div',{attrs:{"id":"add"}},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.tableData,"highlight-current-row":""}},[_vm._l((_vm.exportExcelArry),function(item,index){return [_c('el-table-column',{attrs:{"prop":item.prop,"label":item.label}})]})],2)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2f65f946","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ExportExcelCommon.vue
// module id = null
// module chunks = 